import { render, staticRenderFns } from "./SaveChangesButton.vue?vue&type=template&id=caab0e7a"
import script from "./SaveChangesButton.vue?vue&type=script&lang=js"
export * from "./SaveChangesButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports